export const IMAGE_ASSET_VERSION = 'image-fallbacks-1';

export const getImageAssetUrl = (path) =>
  `${process.env.PUBLIC_URL}${path}?v=${IMAGE_ASSET_VERSION}`;

export const applyImageFallback = (event, fallbackPath) => {
  const image = event.currentTarget;

  if (image.dataset.fallbackApplied === 'true') return;

  image.dataset.fallbackApplied = 'true';
  image.src = getImageAssetUrl(fallbackPath);
};
